<template>
  <ResultPay/>
</template>
<script>
import ResultPay from 'place/pay/resultPay.vue'
export default {
    components:{
      ResultPay
    }
}
</script>